import requests from './Setup'
import { API_URL } from 'config/env'

const RESOURCE = `/Dashboards`

const Dashboards = {
  get: () =>
    requests.get(`${API_URL}${RESOURCE}`).then(response => response.data),
}

export default Dashboards